import { ContentPagePaged } from '.';
import { SearchType } from '@nrwl/rx-models';

export class ContentSection {
  id?: number;
  clinic?: number;
  section_group: number;
  name: string;
  banner?: string;
  order?: number;
  is_stock?: boolean;
  is_published?: boolean;
  is_deleted?: boolean;
  pages: ContentPagePaged;
  position_after?: number;

  constructor(data: any = {}) {
    this.id = data.id || void 0;
    this.clinic = data.clinic || 0;
    this.section_group = data.section_group || void 0;
    this.name = data.name || void 0;
    this.banner = data.banner || null;
    this.order = data.order || 0;
    this.is_published = data.is_published;
    this.is_stock = data.is_stock;
    this.is_deleted = data.is_deleted;
    this.pages = data.pages || void 0;
    this.position_after = data.position_after || 0;
  }

  public ofType = (type: SearchType) => {
    const stock = this.is_stock === true;
    const deleted = this.is_deleted === true;

    switch (type) {
      case SearchType.RxLibrary:
        return stock === true && !deleted && !this.is_published;
      case SearchType.RxLibraryArchived:
        return stock && deleted === true && !this.is_published;
      case SearchType.GlobalLibrary:
        return stock === true && !deleted && this.is_published;
      case SearchType.GlobalLibraryArchive:
        return stock && deleted === true && this.is_published;
      case SearchType.AccountLibrary:
        return stock === false && !deleted;
      case SearchType.AccountLibraryArchive:
        return stock === false && deleted === true;
    }
    return false;
  };

  public getType(): any {
    const stock = this.is_stock === true;
    const deleted = this.is_deleted === true;

    // RxLibrary Active
    if (stock === true && !deleted && !this.is_published) {
      return SearchType.RxLibrary;
    }
    // RxLibrary Archived
    if (stock === true && deleted && !this.is_published) {
      return SearchType.RxLibraryArchived;
    }

    // RxGlobal Active
    if (stock === true && !deleted && this.is_published) {
      return SearchType.GlobalLibrary;
    }
    // RxGlobal Archived
    if (stock && deleted === true && this.is_published) {
      return SearchType.GlobalLibraryArchive;
    }

    // RxAccount Active
    if (stock === false && !deleted) {
      return SearchType.AccountLibrary;
    }
    // RxAccount Archived
    if (stock === false && deleted === true) {
      return SearchType.AccountLibraryArchive;
    }
    return SearchType.RxLibrary;
  }
}

export class ContentSectionPaged {
  count: number;
  previous: string;
  categoryId: number;
  results: ContentSection[];

  constructor(data: any = {}) {
    this.count = data.count;
    this.previous = data.preview;
    this.categoryId = data.categoryId;
    this.results = data.results.map((item) => new ContentSection(item));
  }
}
